"use client";

import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { createRestDataProviderClient } from "@providers/data-provider/rest-data-provider.client";
import { HighlightedText } from "@shared/ui";
import { transformQueryParamsWithoutLocale } from "@shared/utils";
import { Skeleton } from "@ubud-ui/react-ui-kit";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";

type City = {
  id: string;
  name: string;
};

export function CityResult({ keyword, onClick }: { keyword: string; onClick: () => void }) {
  const restDataProviderClient = createRestDataProviderClient();

  const { data: result, isFetching } = useQuery<{ data: City[] }>({
    queryKey: ["header-search-cities", keyword],
    queryFn: () =>
      restDataProviderClient.custom({
        url: transformQueryParamsWithoutLocale("/karirhub/onboarding/v2/cities", {
          limit: 5,
          keyword: keyword,
        }),
        method: "GET",
      }),
    enabled: !!keyword,
  });

  const getFilter = (city: City) => {
    return transformQueryParamsWithoutLocale("/lowongan-dalam-negeri/lowongan", {
      locations: [
        {
          id: city.id,
          label: city.name,
          type: "city",
        },
      ],
    });
  };

  if (isFetching) {
    return (
      <div className="space-y-2 mt-1">
        {[1, 2, 3, 4, 5].map((it) => {
          return (
            <div className="rounded-lg relative h-10 overflow-hidden" key={it}>
              <Skeleton className="absolute w-full h-full bg-gray-200" />
            </div>
          );
        })}
      </div>
    );
  }

  if (result && result.data?.length <= 0) {
    return <></>;
  }

  return (
    <div className="mt-1">
      {result?.data?.map((item) => {
        return (
          <Link key={item.id} href={getFilter(item)} className="flex items-start hover:bg-gray-200 rounded-lg p-3 gap-2" onClick={onClick}>
            <MagnifyingGlassIcon className="size-5 min-w-5 mt-1" />
            <div className="flex-1">
              Cari lowongan di{" "}
              <span className="font-semibold">
                <HighlightedText keyword={keyword} text={item.name} />
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
